export const formatPhoneNumber = (phoneNumber) => {
    // Remove any non-digit characters (just in case)
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');

    // Check if the input is valid (10 digits)
    if (cleaned.length !== 10) {
        return phoneNumber; // Return the original input if invalid
    }

    // Format the phone number (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return phoneNumber; // Return the original input if not formatted
};

export const numberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
